/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-cut': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.563 12.269L12.65 10l3.912-2.269a3.125 3.125 0 00-.756-5.75 3.125 3.125 0 00-3.513 4.6c.342.589.867 1.05 1.495 1.313L11.4 9.275l-8.9-5.15-.625 1.088L10.15 10l-8.275 4.8.625 1.087 8.9-5.162 2.387 1.381a3.125 3.125 0 00-1.493 1.313 3.125 3.125 0 003.512 4.6 3.125 3.125 0 00.757-5.75zm-3.188-6.313a1.875 1.875 0 01.688-2.575 1.875 1.875 0 012.562.694 1.875 1.875 0 01-.688 2.569 1.875 1.875 0 01-2.562-.688zm3.25 10a1.875 1.875 0 01-2.563.694 1.875 1.875 0 01-.687-2.575 1.875 1.875 0 012.563-.688 1.875 1.875 0 01.687 2.538v.031z"/>'
  }
})
